var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-container"},[_c('div',{staticClass:"head-content",style:(_vm.isMobile == true ? 'width:315px' : '')},[_c('img',{attrs:{"src":require("../imgs/logo-change.png"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }